import React from 'react';
import { Bookmark } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useSaved } from '../lib/SavedContext';
import { useAuth } from '../lib/AuthContext';

export const BookmarkButton = ({ item, className = '', size = 'sm' }) => {
  const { user } = useAuth();
  const { isSaved, toggleSaved } = useSaved();
  const navigate = useNavigate();
  const saved = isSaved(item.item_id, item.type || 'article');
  const sz = size === 'lg' ? 'w-5 h-5' : 'w-4 h-4';
  const pad = size === 'lg' ? 'p-2' : 'p-1.5';

  const handleClick = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (!user) { navigate('/auth'); return; }
    await toggleSaved(item);
  };

  return (
    <button
      onClick={handleClick}
      className={`${pad} transition-all z-20 ${
        saved
          ? 'text-[#e8ff00] bg-[#e8ff00]/15 border border-[#e8ff00]/40'
          : 'text-zinc-400 bg-black/40 backdrop-blur-sm border border-zinc-700/50 hover:text-[#e8ff00] hover:border-[#e8ff00]/30'
      } ${className}`}
      title={saved ? 'Remove from saved' : 'Save for later'}
      data-testid={`bookmark-${item.type || 'article'}-${item.item_id}`}
    >
      <Bookmark className={`${sz} ${saved ? 'fill-current' : ''}`} />
    </button>
  );
};
